export default {
  button: {
    addDistributors: 'Tambahkan Distributor',
    addMore: 'Tambahkan lagi',
    addMoreProduct: 'Tambahkan produk lainnya',
    addMoreProductForGiving: 'Tambahkan produk lain untuk diberikan',
    addMoreProductForOrder: 'Tambahkan produk lain untuk dipesan',
    addMoreTime: 'Tambahkan waktu',
    addNewGroup: 'Tambahkan Grup Baru',
    addProduct: 'Tambahkan Produk',
    addSalesOrder: 'Tambahkan Pesanan Penjualan',
    addStoreToGroup: 'Tambahkan Toko ke Grup',
    addStores: 'Tambahkan toko',
    addToStoreGroup: 'Tambahkan ke Grup Toko',
    agree: 'Setuju',
    alreadyInOperation: 'Sudah beroperasi',
    assign: 'Tetapkan',
    btnCode: 'Lihat QR Code Undangan Toko',
    cancel: 'Batal',
    clear: 'Hapus',
    clearSelected: 'Hapus Pilihan',
    close: 'Tutup',
    confirm: 'Konfirmasi',
    continueEditing: 'Lanjutkan Mengedit',
    copyLink: 'Salin tautan',
    create: 'Buat',
    createANewReOrder: 'Buat Pemesanan Ulang Baru',
    createNewDistributorMapping: 'Buat Pemetaan Distributor Baru',
    createNewStoreVisit: 'Buat Kunjungan Toko Baru',
    delete: 'Hapus',
    detail: 'Detail',
    distributorDetial: 'Detail Distributor',
    edit: 'Edit',
    eventApplication: 'Pengajuan Acara',
    eventExecution: 'Pelaksanaan acara',
    exchange: 'Tukar',
    gotIt: 'Mengerti',
    ignore: 'Abaikan',
    invitationInfo: 'Informasi Undangan',
    inviteStoresToParticipate: 'Undang Toko untuk Berpartisipasi',
    launch: 'Luncurkan',
    login: 'Masuk',
    manage: 'Kelola',
    navigate: 'Navigasi',
    nextStep: 'Langkah Berikutnya',
    previous: 'Sebelumnya',
    reject: 'Tolak',
    remove: 'Hapus',
    reset: 'Atur Ulang',
    review: 'Tinjau',
    save: 'Simpan',
    search: 'Cari',
    select: 'Pilih',
    selected: 'Dipilih',
    sellOut: 'Sell-Out',
    stillCancel: 'Tetap Batalkan',
    storeDetial: 'Detail Toko',
    storeInfo: 'Informasi toko',
    storeTagDetermination: 'Penetapan Tag Toko',
    submit: 'Kirim',
    submitForReview: 'Kirim untuk ditinjau',
    thinkAgain: 'Pertimbangkan Lagi',
    types: 'jenis',
    viewActivatedStores: 'Lihat Toko yang Telah Diaktifkan',
    viewRecentReOrder: 'Lihat Pemesanan Ulang Terbaru',
    viewRecentVisitRecords: 'Lihat Catatan Kunjungan Terbaru',
    viewStoreMotivationStatus: 'Lihat Status Motivasi Toko',
    visitInfo: 'Informasi Kunjungan'
  },
  form: {
    achievementRate: 'Tingkat Pencapaian',
    actualTraffic: 'Jumlah Pengunjung Aktual (Periode Acara)',
    addToSchedule: 'Tambahkan ke Jadwal',
    address: 'Alamat',
    afterSalesQuantityPcs: 'Jumlah Device After-sales (Pcs)',
    afterSalesService: 'Layanan After-sales',
    afterTheEvent: 'Setelah acara',
    assignedBaBd: 'BA / BD yang Ditugaskan',
    averageOfDisposableCustomerTraffic: 'Rata-rata Pengunjung Pelanggan Device Disposable',
    averageOfOpenSystemCustomerTraffic: 'Rata-rata Pengunjung Pelanggan Device Open System',
    averageOfTraffic: 'Rata-rata Jumlah Pengunjung',
    averagePassengerFlow: 'Rata-rata Arus Pengunjung',
    averageSalesPcsDay: 'Rata-rata Penjualan (Pcs/Hari)',
    bannerFloorStandProductModelNotes: 'Model Produk pada Banner / Stand Lantai (Catatan)',
    basicInfo: 'Informasi dasar',
    beforeTheEvent: 'Sebelum acara',
    brandBannerDisplayed: 'Banner Merek Dipajang',
    brandBannerProductModelNotes: 'Model Produk pada Banner Merek (Catatan)',
    brandBuyers: 'Pembeli Merek',
    brandDay: 'Hari Merek',
    brandSupplierDistributor: 'Pemasok Merek (Distributor)',
    business: 'Bisnis',
    businessStatus: 'Status Bisnis',
    businessType: 'Jenis Bisnis',
    chainOrNot: 'Chain Store atau Bukan',
    checkInPhoto: 'Foto Check-in',
    chooseDate: 'Pilih Tanggal',
    cityNeighborhoodStreetOrBuilding: 'Kota, kawasan, jalan, atau gedung',
    competitorPrice: 'Harga Kompetitor',
    consumablesRatio: 'Rasio Barang Habis Pakai (Rasio Pod terhadap Mod / Koil terhadap Device)',
    contactPosition: 'Posisi Kontak',
    corePromotedProductBrand: 'Merek Produk Utama yang Dipromosikan',
    country: 'Negara',
    createANewStoreMapping: 'Buat pemetaan toko baru',
    currentProductListingStatus: 'Status Pendaftaran Produk Saat Ini',
    customerReach: 'Jangkauan Pelanggan',
    dayOfPromotion: 'Hari Promosi',
    daysInAdvance: 'Jumlah Hari Sebelumnya',
    decisionMakerInfo: 'Informasi Pengambil Keputusan',
    decisionMakerName: 'Nama Pengambil Keputusan',
    decisionMakerRole: 'Jabatan Pengambil Keputusan',
    directOrNot: 'Langsung atau Tidak',
    directSellIn: 'Penjualan Masuk Langsung',
    displayMerchandising: 'Display dan Penataan Produk',
    displayPhoto: 'Foto Display',
    disposable: 'Device Disposable',
    disposableBrandDiversity: 'Variasi Merek Device Disposable',
    disposableCustomerTraffic: 'Traffic Pelanggan Device Disposable',
    disposableSales: 'Penjualan Device Disposable',
    distributorID: 'ID Distributor',
    distributorName: 'Nama Distributor',
    distributorNamePostCodeAddressCityVisitBa: 'Nama Distributor/Kode Pos/Alamat/Kota/ Kunjungan BA',
    distributorTag: 'Tag Distributor',
    distributorType: 'Jenis Distributor',
    eXWEstimatedPrice: 'Estimasi Harga EXW ($)',
    editReason: 'Edit Alasan',
    email: 'Email',
    endOfSales: 'Akhir Penjualan',
    endTime: 'Waktu Selesai',
    estimatedPriceOfConsumablesEXW: 'Estimasi Harga EXW Device Disposable ($)',
    eventActualSales: 'Penjualan Aktual Acara (Pcs)',
    eventFeedback: 'Feedback acara',
    eventPhotos: 'Foto acara',
    eventSellInStoreTarget: 'Target Sell-In toko di Acara',
    eventStoreContactName: 'Nama Kontak Toko untuk Acara',
    eventTime: 'Waktu acara',
    eventType: 'Jenis acara',
    expectedTime: 'Perkiraan Waktu',
    facebookInstagramAvailable: 'Facebook / Instagram Tersedia',
    firistOrder: 'Pesanan Pertama',
    firstTimeOrNot: 'Pertama Kali atau Bukan',
    footTrafficInformation: 'Informasi Jumlah Pengunjung',
    image: 'Gambar',
    inv: 'Stock',
    invalid: 'Tidak Valid',
    inventory: 'Stock',
    invitationsInfo: 'Informasi undangan',
    isItRecommendedForRoutineOperation: 'Apakah direkomendasikan untuk operasional rutin?',
    isThereAnInvitationForAnEvent: 'Apakah ada undangan acara?',
    kOSGroupInvitation: 'Undangan Grup KOS',
    kOSGroupJoinScreenshot: 'Gambar Screnshot Bergabung ke Grup KOS',
    keyDistributor: 'Distributor Utama',
    lastest: 'Terbaru',
    listed: 'Sudah Terdaftar',
    listing: 'Pendaftaran Produk',
    listingOrNot: 'Terdaftar atau Tidak',
    listingProductSupplierDistributor: 'Distributor Terdaftar (Distributor)',
    listingStatus: 'Status Pendaftaran Produk',
    lssueDeviceMode: 'Mode Perangkat Bermasalah',
    lssusDescription: 'Deskripsi Masalah',
    mDWholesalePrice: 'Harga Grosir MD ($)',
    marketFeedback: 'Feedback Pasar',
    marketInformationCollection: 'Pengumpulan Informasi Pasar',
    materialDelivery: 'Pengiriman POSM',
    materialSampleDelivery: 'Pengiriman POSM dan Sampel',
    materialSamplePhoto: 'Foto POSM dan Sampel',
    month: 'Bulan',
    monthlyAverageSalesForKit: 'Rata-rata Penjualan Bulanan Kit (Pcs)',
    name: 'Nama',
    namePostCodeAddressCity: 'Nama/Kode Pos/Alamat/Kota',
    newBuyers: 'Pembeli baru',
    newBuyersReOrderStoreCount: 'Jumlah Pembeli Baru dan Toko yang Memesan Ulang',
    newGroup: 'Grup Baru',
    notKeyDistributor: 'Bukan Distributor Utama',
    notListing: 'Belum Terdaftar',
    notes: 'Catatan',
    numberOfAffiliatedCoreStore: 'Jumlah Toko Utama Terafiliasi',
    numberofChainStores: 'Jumlah Toko Berantai',
    officialWebsiteAvailable: 'Situs Web Resmi Tersedia',
    openSystem: 'Open System',
    openSystemCustomerTraffic: 'Pengunjung Open System',
    openSystemSales: 'Penjualan Open System',
    orderGiftVolume: 'Jumlah Hadiah Pesanan',
    orderModificationHistory: 'Riwayat Perubahan Pesanan',
    orderSalesVolume: 'Volume Penjualan Pesanan',
    orders: 'pesanan',
    other: 'Lainnya',
    otherCategory: 'Kategori lainnya',
    otherCosts: 'Biaya lainnya (POSM, dll.)',
    otherDistributor: 'Distributor Lainnya',
    outsidePicture: 'Foto Bagian Luar',
    overallSalesPerformance: 'Kinerja Penjualan Keseluruhan',
    pO: 'PO',
    pOOrder: 'Order PO',
    paid: 'Sudah Dibayar',
    passengerFlowStatistics: 'Statistik Arus Pengunjung (Periode Acara)',
    password: 'Kata Sandi',
    paymentStatus: 'Status Pembayaran',
    paymentType: 'Jenis Pembayaran',
    pcs: 'Pcs',
    percentageOfDisposable: 'Persentase Produk Disposable',
    percentageOfOpenSystem: 'Persentase Open System',
    permanentlyClosed: 'Tutup Permanen',
    phone: 'Telepon',
    phoneNumber: 'Nomor Telepon',
    photo: 'Foto',
    planName: 'Nama Rencana',
    plannedVisitDate: 'Tanggal Kunjungan yang Direncanakan',
    pleaseSelect: 'Silakan pilih',
    poPhoto: 'Foto PO',
    policy: 'Kebijakan',
    popUp: 'Pop-up',
    popupDisplayPics: 'Foto Display Pop-up',
    position: 'Posisi',
    posterDisplayed: 'Poster Dipajang',
    preEventWarmUpCooperation: 'Kerja Sama Promosi Pre - event',
    productCashCheque: 'Produk + Cash/Cek',
    productDailySales: 'Penjualan Harian Produk',
    productInfo: 'Informasi produk',
    productListingStatus: 'Status Pendaftaran Produk',
    productSalesInventory: 'Penjualan dan Stock Produk',
    promotionCapability: 'Kemampuan Promosi',
    promotionCapabillty: 'Kemampuan Promosi',
    promotionEffect: 'Efektivitas Promosi',
    quantityGivenAwayPcs: 'Jumlah yang Dibagikan (Pcs)',
    quantitySoldPcs: 'Jumlah yang Terjual (Pcs)',
    receipt: 'Nota',
    recommendationsEventInvitations: 'Rekomendasi dan Undangan Acara',
    recommendedForRoutineOperation: 'Direkomendasikan untuk operasional rutin',
    reorderBuyers: 'Pembeli yang memesan ulang',
    retailPrice: 'Harga Eceran',
    retailPriceMoney: 'Harga Eceran ($)',
    retailerPurchasePrice: 'Harga Beli Peritel',
    rollUpBannerOrFloorStandDisplay: 'Display Banner Gulung atau Stand Lantai',
    ruleTipsOne: 'Silakan Pilih Toko',
    salesBeforePromotion: 'Penjualan Sebelum Promosi (Pcs/Hari)',
    salesPcs: 'Penjualan (Pcs)',
    salesPcsWeek: 'Penjualan (Pcs/Minggu)',
    salesPerformance: 'Kinerja Penjualan',
    salesPerformancePcs: 'Kinerja Penjualan (Pcs)',
    salesReorderForecast: 'Perkiraan Penjualan dan Pemesanan Ulang',
    salesTargetForThisEventPcs: 'Target Penjualan Acara Ini (Pcs)',
    sample: 'Sampel',
    sampleConsumed: 'Sampel yang digunakan',
    sampleDelivery: 'Pengiriman Sampel',
    sampleGiveawayPcs: 'Sampel yang Dibagikan (Pcs)',
    samplePhoto: 'Foto Sampel',
    searchBrandOrProduct: 'Cari merek atau produk...',
    selectEndTime: 'Pilih Waktu Selesai',
    selectProductsToUpdateListingStatus: 'Pilih produk untuk memperbarui status pendaftaran',
    selectStartTime: 'Pilih Waktu Mulai',
    selectTimePeriod: 'Pilih rentang waktu',
    sellInByMyselfThisTime: 'Penjualan masuk oleh saya kali ini',
    sellInFromAcmefog: 'Penjualan masuk dari Acmefog',
    sellInFromDistributor: 'Penjualan masuk dari Distributor',
    sellInPhoto: 'Foto Penjualan Masuk',
    sellInQuantity: 'Jumlah Sell- In (Pcs)',
    sellOutOrders: 'Pesanan Sell- Out',
    sentOut: 'Sudah Dikirim',
    servicePhoto: 'Foto Layanan',
    staffName: 'Nama Staff',
    startTime: 'Waktu Mulai',
    storeCapacityVerification: 'Verifikasi kapasitas toko',
    storeGroup: 'Grup Toko',
    storeID: 'ID Toko',
    storeName: 'Nama Toko',
    storeNamePostCodeAddressCityVisitBa: 'Nama Toko/Kode Pos/Alamat/Kota/Kunjungan BA',
    storePurchasePrice: 'Harga Beli Toko ($)',
    storeServiceRecords: 'Catatan Layanan Toko',
    storeTag: 'Tag Toko',
    storeType: 'Jenis Toko',
    supportsPreEventInStoreDisplay: 'Mendukung Display Dalam Toko Sebelum Event',
    tax: 'Pajak',
    taxExclusive: 'Belum Termasuk Pajak',
    taxInclusive: 'Termasuk Pajak',
    temporarilyClosed: 'Tutup Sementara',
    testingStationDisplayed: 'Stasiun Uji Coba Dipajang',
    testingStationProductModelNotes: 'Model Produk di Stasiun Uji Coba (Catatan)',
    timePeriods: 'Rentang Waktu',
    total: 'Total',
    totalDisposableSales: 'Total Penjualan Produk Disposable (Pcs/Minggu)',
    totalOpenSystemSales: 'Total Penjualan Open System (Pcs/Minggu)',
    totalOpenSystemsSales: 'Total Penjualan Open System (Pcs/Minggu)',
    totalProductSales: 'Total Penjualan Produk',
    totalSalesInStoreDuringEvent: 'Total Penjualan Toko Selama Acara (Pcs)',
    totalSalesPcs: 'Total Penjualan (Pcs)',
    totalSellIn: 'Total Sell-in',
    totalStoreTraffic: 'Total Pengunjung Toko',
    totalUsed: 'Total Digunakan',
    uSD: 'USD',
    unpaid: 'Belum Dibayar',
    userName: 'Nama Pengguna',
    visitDate: 'Tanggal Kunjungan',
    visitInfo: 'Informasi kunjungan',
    warmUp: 'Promosi Awal',
    warmUpType: 'Jenis Promosi Awal',
    wayOfList: 'Cara Pendaftaran Produk',
    weekdayFootTraffic: 'Jumlah Pengunjung Hari Kerja',
    weekdayPeakTraffic: 'Puncak Pengunjung Hari Kerja',
    weekendFootTraffic: 'Jumlah Pengunjung Akhir Pekan',
    weekendPeakTraffic: 'Puncak Pengunjung Akhir Pekan',
    weeklySalesInventoryBrforeEventPcs: 'Penjualan dan Inventaris Mingguan Sebelum Acara (Pcs)',
    whatsAppGroupAvailable: 'Grup WhatsApp Tersedia',
    wholesalePurchasePrice: 'Harga Beli Grosir',
    wholesaleRetailerPurchasePrice: 'Harga Beli Grosir dan Retail (USD)'
  },
  shared: {
    activity: 'Aktivitas',
    addDistributorsToThePlan: 'Tambahkan distributor ke rencana',
    addNewStoreMapping: 'Tambahkan Pemetaan Toko Baru',
    addNewStoreVisit: 'Tambahkan Kunjungan Toko Baru',
    addNewVisitSchedulePlannedVisitDate: 'Tambahkan Jadwal Kunjungan Baru, Tanggal Kunjungan yang Direncanakan:',
    addRetailStoresToThePlan: 'Tambahkan toko ritel ke rencana',
    addToExistingPlan: 'Tambahkan ke rencana yang sudah ada',
    addToVisitPlan: 'Tambahkan ke Rencana Kunjungan',
    agreeToApplicationForKickOutOfOperation: 'Setujui pengajuan pengeluaran dari Operasional',
    anEventToBeHeld: 'Acara yang akan dilaksanakan',
    aplyToKickOutOfOperation: 'Ajukan pengeluaran dari Operasional',
    applicable: 'Berlaku',
    applicant: 'Pemohon',
    applicationForKickOutOfOperation: 'Pengajuan pengeluaran dari Operasional',
    approvalTime: 'Waktu persetujuan',
    approved: 'Disetujui',
    approver: 'Pemberi Persetujuan',
    auditResult: 'Hasil Audit',
    automaticallyAddCurrentItemAfterCreation: 'Tambahkan item saat ini secara otomatis setelah dibuat',
    bA: 'BA',
    balance: 'Saldo',
    bindProduct: 'Hubungkan Produk',
    brandDayApplication: 'Pengajuan Hari Merek',
    buy: 'Beli',
    by: 'oleh',
    byDay: 'Berdasarkan Hari',
    byTime: 'Berdasarkan Waktu',
    byVisitBy: 'Kunjungan oleh',
    cancelAllocationOfStores: 'Batalkan alokasi toko',
    cancelBrandDay: 'Batalkan Hari Merek',
    cancelPopUpEvent: 'Batalkan Acara Pop-up',
    cancelVisitSchedule: 'Batalkan Jadwal Kunjungan',
    changeDetails: 'Detail Perubahan',
    closed: 'Tutup',
    collecting: 'Sedang Dikumpulkan',
    completed: 'Selesai',
    confirmRedemaption: 'Konfirmasi Penukaran',
    createNewVisitPlan: 'Buat rencana kunjungan baru',
    createVisitPlan: 'Buat rencana kunjungan',
    creditBreakdown: 'Rincian Poin',
    creditEarned: 'Poin yang Diperoleh',
    creditTransactionHistory: 'Riwayat Transaksi Poin',
    current: 'Saat Ini',
    daily: 'Harian',
    dateOfInvitation: 'Tanggal undangan',
    day: 'Hari',
    daysAgo: 'hari yang lalu',
    deadline: 'Batas Waktu',
    development: 'Pengembangan',
    distributor: 'Distributor',
    distributors: 'Distributor',
    distroInfo: 'Informasi distributor',
    dynamics: 'Aktivitas Terkini',
    earnedPoints: 'memperoleh {totalIntegral} poin',
    end: 'Selesai',
    event: 'Acara',
    eventExecute: 'Laksanakan Acara',
    eventInvitations: 'Undangan acara',
    eventInvite: 'Undang ke Acara',
    eventPolicy: 'Kebijakan Acara',
    expectTime: 'Perkiraan waktu',
    feedback: 'Feedback',
    filter: {
      accountManagement: 'Manajemen Akun',
      activated: 'Aktif',
      all: 'Semua',
      allType: 'Semua Jenis',
      average: 'Rata-rata',
      brand: 'Merek',
      brandFilter: 'Filter Merek',
      confirm: 'Konfirmasi',
      containAll: 'Memuat (Semua)',
      containAny: 'Memuat (Salah Satu)',
      customize: 'Sesuaikan',
      distanceEarliest: 'Mapping Toko: Paling Awal',
      distanceFarthest: 'Jarak: Paling Jauh',
      distanceLatest: 'Mapping Toko: Terbaru',
      distanceNearest: 'Jarak: Paling Dekat',
      effective: 'Efektif',
      endDate: 'Tanggal Selesai',
      filter: 'Filter',
      good: 'Baik',
      goodTop: 'Baik: Merek kelas atas dan menengah',
      high: 'Tinggi',
      inMonth: 'Dalam satu bulan',
      inTwoWeeks: 'Dalam dua minggu',
      inWeek: 'Dalam satu minggu',
      incentiveHistory: 'Riwayat Insentif',
      kA: 'KA',
      lessThanDays: 'Kurang dari 7 hari',
      low: 'Rendah',
      mD: 'MD',
      me: 'Saya',
      needTo: 'Perlu',
      no: 'Tidak',
      noFilter: 'Tanpa Filter',
      notActivated: 'Belum Aktif',
      notContainAny: 'Tidak memuat (Salah Satu)',
      notEqualTo: 'Tidak sama dengan (Semua)',
      notNeedTo: 'Tidak perlu',
      notParticipated: 'Tidak Berpartisipasi',
      notSet: 'Belum diatur',
      operationBottonmost: 'Operasional: Paling Bawah',
      operationTopmost: 'Operasional: Paling Atas',
      participated: 'Berpartisipasi',
      poor: 'Kurang',
      poorMainly: 'Kurang: Didominasi merek kelas atas',
      potential: 'Potensial',
      procMgr: 'Manajer Pengadaan',
      product: 'Produk',
      reset: 'Atur Ulang',
      rich: 'Lengkap',
      richTop: 'Lengkap: Merek kelas atas, menengah, dan kecil',
      russia: 'Rusia',
      sDMultiItemDistro: 'SD (Distributor Multi-item)',
      sDSmokeDistro: 'SD (Distributor Produk Tembakau)',
      sVIPCore: 'Core SVIP',
      salesclerk: 'Pramuniaga',
      selectDate: 'Pilih Tanggal',
      selectEndDate: 'Pilih Tanggal Selesai',
      selectStartDate: 'Pilih Tanggal Mulai',
      shopkeeper: 'Penjaga Toko',
      sort: 'Urutkan',
      startDate: 'Tanggal Mulai',
      time: 'Waktu',
      timeDays: '7~15 hari',
      timeFilter: 'Filter Waktu',
      toBeVerified: 'Menunggu Verifikasi',
      type: 'Jenis',
      typeFilter: 'Filter Jenis',
      unitedKingdom: 'Britania Raya',
      unitedStates: 'Amerika Serikat',
      unknown: 'Tidak Diketahui',
      vIPCore: 'Core SVIP',
      viewStore: 'Lihat Toko',
      yes: 'Ya'
    },
    from: 'dari',
    get: 'Dapatkan',
    giveUpReason: 'Alasan Membatalkan',
    hideUpdate: 'Sembunyikan "perbarui"',
    insufficientPoints: 'Poin Tidak Cukup',
    inventoryPcs: 'Stock (Pcs)',
    inviteFansToJoinTheCommunity: 'Undang penggemar untuk bergabung ke komunitas',
    kickOut: 'Keluarkan',
    kickOutOfOperation: 'Keluarkan dari Operasional',
    kilometer: 'km',
    launchPopUpEvent: 'Luncurkan Acara Pop-up',
    listingProduct: 'Produk Terdaftar',
    loading: 'Memuat...',
    locationName: 'Nama lokasi',
    mapping: 'Mapping',
    markToIgnoreThisTransferAllocation: 'Tandai untuk mengabaikan transfer dan alokasi ini',
    materialSample: 'Materi/Sampel',
    materialSampleDeliveryDataMaintenance: 'Maintenance data pengiriman POSM dan sampel',
    metre: 'm',
    modifiedProductQuantity: 'Jumlah Produk yang Diubah',
    modifyBrandDayApplicationInfo: 'Ubah informasi Pengajuan Hari Merek',
    modifyPersonalInformation: 'Ubah informasi pribadi',
    modifyReOrder: 'Ubah Pemesanan Ulang',
    modifyStoreTag: 'Ubah Tag Toko',
    more: 'Lainnya',
    multiStopRoute: 'Rute Beberapa Pemberhentian',
    myApproval: 'Persetujuan Saya',
    nearbyStores: 'Toko Terdekat',
    need: 'Perlu',
    newDistributorMapping: 'Mapping Distributor Baru',
    newDistributorVisit: 'Kunjungan distributor baru',
    newReOrder: 'Pemesanan Ulang Baru',
    newVisitSellIn: 'Kunjungan dan Penjualan Masuk Baru',
    nonEditable: 'Tidak dapat diedit',
    none: 'Tidak Ada',
    notChangedYet: 'Belum ada perubahan',
    notStarted: 'Belum dimulai',
    offSite: 'Di Luar Lokasi',
    onSite: 'Di Lokasi',
    operation: 'Operasional',
    overdueFollowUp: 'Tindak lanjut terlambat',
    pendingReview: 'Menunggu Peninjauan',
    plannedVisitDate: 'Tanggal kunjungan yang direncanakan',
    point: 'Poin',
    pointsRank: 'Peringkat Poin',
    preEvent: 'Pre-event',
    productBindingRecords: 'Catatan Penghubungan Produk',
    productDetails: 'Detail Produk',
    proofOfDelivery: 'Bukti Pengiriman',
    psi: 'PSI',
    quanntityGivenAway: 'Jumlah yang dibagikan',
    quanntitySold: 'Jumlah yang terjual',
    reason: 'Alasan',
    records: 'catatan',
    redeemIncentiveRewardsForEmployees: 'Tukarkan Hadiah Insentif untuk Karyawan',
    redeemedCredit: 'Poin yang Ditukarkan',
    rejectApplicationForKickingOutUpStore: 'Tolak pengajuan pengeluaran toko',
    rejected: 'Ditolak',
    relevantVisitPlans: 'Rencana Kunjungan Terkait',
    removedDistributor: 'Distributor yang Dihapus',
    removedProducts: 'Produk yang Dihapus',
    reorder: 'Pemesanan Ulang',
    reorderPcs: 'Pemesanan Ulang (Pcs)',
    report: 'Laporan',
    reportPopUpEventExecutionStatus: 'Laporkan Status Pelaksanaan Acara Pop-up',
    reportingOnTheBrandDayExecution: 'Laporan Pelaksanaan Hari Merek',
    reviewStatus: 'Review Status',
    rules: 'Aturan',
    sN: 'SN',
    salesPcsWeek: 'Penjualan (Pcs/Minggu)',
    schedule: 'Jadwal',
    selectDistributor: 'Pilih Distributor',
    selectFromExistingPlan: 'Pilih dari 4 rencana yang tersedia',
    selectGiftToRedeem: 'Pilih Hadiah untuk Ditukarkan',
    selectStore: 'Pilih Toko',
    selectType: 'Pilih Jenis',
    sellOutDataMaintenance: 'Pemeliharaan data penjualan keluar',
    sellOutProduct: 'Produk Penjualan Keluar',
    setAssignedBABDInTheManagementSystem: 'Tetapkan BA/BD yang Ditugaskan dalam Sistem Manajemen',
    setStoreLabels: 'Atur label toko',
    setStoreTag: 'Atur Tag Toko',
    setTheResponsiblePerson: 'Tetapkan penanggung jawab',
    startingNow: 'Mulai sekarang',
    store: 'Toko',
    storeActivity: 'Aktivitas Toko',
    storeAllocationTime: 'Waktu alokasi toko',
    storeID: 'ID Toko',
    storeIncentive: 'Insentif Toko',
    storeIncentiveBindProduct: 'Insentif Toko: Hubungkan Produk',
    storeIncentiveDeactivateEmployeeAccount: 'Insentif Toko: Nonaktifkan Akun Karyawan',
    storeIncentiveInviteEmployeeToActivate: 'Insentif Toko: Undang Karyawan untuk Mengaktifkan Akun',
    storeIncentiveUploadSalesProof: 'Insentif Toko: Unggah Bukti Penjualan',
    storeOperation: 'Operasional Toko',
    storeParticipant: 'Peserta Toko',
    storeTagChange: 'Perubahan Tag Toko',
    storeToDoItems: 'Daftar Tugas Toko',
    stores: 'Toko',
    storesAreTransferredAndAllocatedTo: 'Toko ditransfer dan dialokasikan kepada',
    storesLevel: 'Tingkat Toko',
    submissionTime: 'Waktu Pengiriman',
    success: 'berhasil',
    summary: 'Ringkasan',
    theFirstSaleOrInvitation: 'Penjualan atau Undangan Pertama',
    timeOfApplication: 'Waktu Pengajuan',
    title: {
      activatedStores: 'Toko yang Telah Diaktifkan',
      anEventStoreToBeHeld: 'Toko tempat acara akan dilaksanakan',
      basicInfo: 'Informasi Dasar',
      createANewGroup: 'Buat grup baru',
      createdSuccessfully: 'Berhasil Dibuat',
      days: 'Hari',
      distributorInfo: 'Informasi Distributor',
      distributorMapping: 'Pemetaan Distributor',
      distributorOperation: 'Operasional Distributor',
      editGroupName: 'Edit nama grup',
      estimationOfResults: 'Perkiraan hasil',
      eventHeld: 'Apakah Acara Pop-up sudah dilaksanakan?',
      eventRecord: 'Catatan Acara',
      filterDepartment: 'Filter berdasarkan departemen',
      filterPerson: 'Filter berdasarkan Orang',
      illDesc: 'Deskripsi Ilustrasi',
      incentive: 'Insentif',
      listState: 'Status Daftar',
      manageMyGroups: 'Kelola Grup Saya',
      mappingSucceed: 'Pemetaan Berhasil',
      marketInsight: 'Wawasan Pasar',
      mySchedule: 'Jadwal Saya',
      orderDetail: 'Detail Pesanan',
      orderUpdateRecord: 'Riwayat Perubahan Pesanan',
      others: 'Lainnya',
      overdueStoreFailureToFollowUp: 'Toko terlambat ditindaklanjuti',
      oversightMatters: 'Hal yang Perlu Diperhatikan',
      participationRecord: 'Catatan Partisipasi',
      pleaseSelectYourWorkItems: 'Silakan pilih item pekerjaan Anda',
      pointsRedemption: 'Penukaran Poin',
      preparations: 'Persiapan',
      productListed: 'Produk Terdaftar',
      prompt: 'Pesan',
      quickEntrance: 'Akses cepat',
      reOrderOrNot: 'Pemesanan Ulang atau Tidak',
      reOrderSellIn: 'Pemesanan Ulang (Sell-In)',
      retailOperationSystem: 'Sistem Operasional Ritel',
      ros: 'ROS',
      selectAPolicy: 'Pilih Kebijakan',
      selectGroup: 'Pilih Grup',
      selectItemOfWork: 'Pilih item pekerjaan',
      selectPlan: 'Pilih Rencana',
      selectRegion: 'Pilih Wilayah',
      selectYearAndMonth: 'Pilih Tahun dan Bulan',
      state: 'Status',
      storeAssignment: 'Penugasan Toko',
      storeDevelopment: 'Pengembangan Toko',
      storeInfo: 'Informasi Toko',
      storeMapping: 'Pemetaan Toko',
      storeTag: 'Tag Toko',
      storeVisit: 'Kunjungan Toko',
      storesToBeAllocated: 'Toko yang akan dialokasikan',
      theNumberOfProductsSold: 'Jumlah produk yang terjual',
      timeSinceLastVisit: 'Waktu Sejak Kunjungan Terakhir',
      transferAllocationRecords: 'Catatan Transfer dan Alokasi',
      transferAndAllocate: 'Transfer dan alokasikan',
      visitByBa: 'Kunjungan oleh BA',
      visitOrNot: 'Dikunjungi atau Tidak',
      whichDay: 'Hari Apa',
      minDays: 'Min Days',
      maxDays: 'Max Days'
    },
    titleEight: 'Acara tidak boleh berlangsung lebih dari {days} hari',
    titleEighteen: 'Yakin ingin menghapus kelayakan peserta ini?',
    titleEleven: 'Langkah 1 Informasi Dasar Acara Saat Ini',
    titleFifteen: 'Langkah 3 Data Pendaftaran dan Penjualan Produk Saat Ini',
    titleFive: 'Pemesanan ulang toko ini baru saja diperbarui. Tetap ingin menambahkan pemesanan ulang?',
    titleFour: 'Informasi kunjungan toko ini baru saja diperbarui. Lanjutkan mengedit?',
    titleFourteen: 'Silakan periksa apakah ada pembaruan. Informasi terbaru akan otomatis ditambahkan ke informasi dasar setelah pengajuan acara berhasil dikirim.',
    titleNine: 'Status acara harus dikirim tepat waktu. Setiap acara hanya perlu diisi satu kali.',
    titleNineteen: 'Kirim isi pemberitahuan di atas kepada orang tersebut melalui SMS',
    titleOne: 'Filter berdasarkan kondisi berikut',
    titleSeven: 'Ringkasan aktivitas berikut dibuat otomatis berdasarkan data yang Anda masukkan',
    titleSeventeen: 'Undang penggemar untuk bergabung ke komunitas dan dapatkan {totalIntegral} poin',
    titleSix: 'Kunjungan toko ini baru saja diperbarui. Tetap ingin membuat kunjungan baru?',
    titleSixteen: 'Langkah 4 Status Persiapan Acara Saat Ini',
    titleTen: 'Status acara harus dikirim setiap hari. Ringkasan acara akan dibuat otomatis setelah acara selesai.',
    titleThirteen: 'Informasi berikut akan ditampilkan otomatis jika pernah diisi sebelumnya.',
    titleThirty: 'Transfer tidak dapat dibatalkan setelah berhasil. Pastikan produk sudah dipajang di toko.',
    titleThirtyOne: 'Rencana kunjungan berhasil dibuat. Toko/Distributor dapat ditambahkan ke rute kunjungan yang direncanakan.',
    titleThirtyThree: 'Apakah status pendaftaran produk perlu diperbarui kali ini?',
    titleThirtyTwo: 'Tambahkan {keyVal} ke rencana kunjungan lainnya',
    titleThree: 'Pemesanan ulang toko ini baru saja diperbarui. Lanjutkan mengedit?',
    titleTwelve: 'Langkah 2 Informasi Dasar {type}',
    titleTwenty: 'Undang staf untuk mengaktifkan kelayakan menerima bonus',
    titleTwentyEight: 'Tingkat toko belum ditentukan sejak aktivitas toko berakhir. Buka untuk mengirimkannya.',
    titleTwentyFive: 'Mengeluarkan toko akan mencabut akses toko dan Anda tidak dapat memperbarui informasi operasionalnya. Harap lakukan dengan hati-hati.',
    titleTwentyFour: 'Jelaskan alasan mengeluarkan toko',
    titleTwentyNine: 'Transfer toko ke "tim operasional" dan tetapkan penanggung jawab',
    titleTwentyOne: 'Penukaran berhasil. Sebanyak {currentIntegral} poin telah dikurangi dari akun karyawan ini.',
    titleTwentySeven: '{backlogUserName}, acara {sourceName} akan dimulai pada {backlogTime}. Buka untuk melihat.',
    titleTwentySix: 'Toko ini memiliki undangan acara yang akan diluncurkan. Lihat informasi undangan.',
    titleTwentyThree: 'telah mengajukan pengeluaran dari Operasional',
    titleTwentyTwo: 'Yakin ingin menghapus produk ini?',
    titleTwo: 'Hanya kunjungan terakhir oleh orang ini',
    titleThirtyFour: 'Fill Min Days, Max Days, or both. Leave a field blank for no corresponding limit.',
    to: 'hingga',
    toBeAllocated: 'Akan dialokasikan',
    today: 'hari ini',
    transferAllocation: 'Transfer dan Alokasi',
    transferAndAssignStoresTo: 'Transfer dan tetapkan toko kepada',
    underReview: 'Sedang Ditinjau',
    updateDistributorMapping: 'Perbarui Pemetaan Distributor',
    updateDistributorVisit: 'Perbarui Kunjungan Distributor',
    updatePopUpEvent: 'Perbarui Acara Pop-up',
    updateRecord: 'Perbarui Catatan',
    updateStoreInfoBy: 'Perbarui informasi toko oleh',
    updateStoreMappingInformation: 'Perbarui Informasi Pemetaan Toko',
    updateStoreVisitInformation: 'Perbarui Informasi Kunjungan Toko',
    updateVisitSellIn: 'Perbarui Kunjungan dan Penjualan Masuk',
    uploadSalesReceipt: 'Upload Bukti Penjualan',
    visit: 'Kunjungan',
    visitPlan: 'Rencana Kunjungan',
    visitSellIn: 'Kunjungan dan Penjualan Masuk',
    visitTime: 'Waktu Kunjungan',
    webSite: 'Situs Web',
    yesterday: 'kemarin'
  },
  tips: {
    accountOrPasswordIncorrect: 'Akun atau kata sandi salah',
    addressCopiedFailed: 'Gagal menyalin alamat',
    addressCopiedSuccessfully: 'Alamat berhasil disalin',
    areYouSureToExit: 'Yakin ingin keluar?',
    browserDoesNotSupportCopyFunction: 'Browser tidak mendukung fungsi salin',
    checkInPhotoIsRequired: 'Foto check-in wajib diunggah',
    chooseOnePersonAtLeast: 'Pilih minimal satu orang',
    distributorPrice: 'Harga Distributor',
    eventCancelled: 'Acara Dibatalkan',
    filterByGroupName: 'Filter berdasarkan Nama Grup',
    isRequired: 'wajib diisi',
    locationNotFound: 'Lokasi tidak ditemukan',
    loginSuccess: 'Berhasil masuk',
    messageEight: 'Jika informasi ini pernah dikirim, data sebelumnya akan terisi otomatis. Silakan edit langsung jika ada perubahan.',
    messageEleven: 'Mencakup Semua Merek Pesaing Produk Sekali Pakai/Sistem Terbuka',
    messageFifteen: 'Yakin ingin menghapus pesanan penjualan ini?',
    messageFifty: 'Apakah rencana kunjungan ini akan dihapus? Jika jadwal sudah dibuat, jadwal tersebut juga akan dibatalkan.',
    messageFiftyOne: 'Ingin menghapus {targetType} saat ini dari rencana kunjungan dan membatalkan jadwal terkait?',
    messageFiftyThree: 'Ingin menghapus rencana kunjungan ini? Jika jadwal sudah dibuat, jadwal tersebut juga akan dibatalkan.',
    messageFiftyTwo: 'Buat jadwal kunjungan secara otomatis untuk toko/distributor yang ditambahkan ke rencana ini',
    messageFive: 'Waktu selesai harus setelah waktu mulai',
    messageForty: 'Pemetaan toko berhasil. Informasi toko lainnya dapat dikumpulkan melalui kunjungan.',
    messageFortyEight: 'Hapus Grup Ini (Tindakan ini hanya menghapus grup, bukan toko di dalamnya.)',
    messageFortyFive: 'Tag Toko saat ini: {customerTag}. Ingin mengubah Tag Toko?',
    messageFortyFour: 'Setelah dihapus, toko tidak akan muncul dalam daftar hingga BA mengirimkannya kembali.',
    messageFortyNine: 'Konfirmasi transfer toko dan penugasannya kepada penanggung jawab yang ditentukan?',
    messageFortyOne: 'Ubah status toko menjadi: {statusVal}. Toko tidak akan dipetakan dan dikunjungi. Lanjutkan?',
    messageFortySeven: 'Jika tinjauan disetujui, akses toko akan dilepas dan toko dipindahkan ke area "Ekspansi". Catatan operasional sebelumnya akan diarsipkan otomatis dan tidak dapat diubah. Harap lakukan dengan hati-hati.',
    messageFortySix: 'Toko akan dipindahkan ke "Pengembangan" dan aksesnya dicabut. Catatan operasional sebelumnya akan diarsipkan dan tidak dapat diedit.',
    messageFortyThree: 'Tidak ada penjualan atau penjualan produk terdaftar, sehingga tidak dapat direkomendasikan',
    messageFortyTwo: 'Sell-In oleh saya kali ini wajib diisi',
    messageFour: 'Tekan lama untuk menyimpan ke galeri foto/album',
    messageFourteen: 'Hapus materi yang dipilih beserta jumlah yang telah diisi?',
    messageNine: 'Menghapus produk akan menghapus jumlah yang dimasukkan. Ingin menghapusnya?',
    messageNineteen: 'Aktivitas yang akan dilaksanakan: Saat toko baru ditugaskan kepada karyawan dan memiliki catatan undangan acara, karyawan harus menyelesaikan presentasi acara serta mengunggah hasil pelaksanaannya dalam waktu yang ditentukan.',
    messageOne: 'Buat grup toko sendiri untuk mengelompokkan toko. Grup toko hanya dapat dilihat oleh pembuat grup.',
    messageSeven: 'Waktu tidak sesuai',
    messageSeventeen: 'Menunggu Peninjauan: Pengajuan yang perlu ditinjau.',
    messageSix: 'Silakan isi informasi secara lengkap',
    messageSixteen: 'Akan dialokasikan: Kirim kunjungan ke toko dalam Kumpulan Toko Grup Pengembangan. Jika setidaknya satu produk sudah dipajang dalam catatan kunjungan, sistem akan otomatis membuat catatan "toko yang akan ditugaskan". Supervisor ritel dapat mentransfer dan menugaskan toko kepada orang yang ditentukan untuk melakukan tindak lanjut dan pemeliharaan.',
    messageTen: 'Masukkan data penjualan sebelum acara hanya pada Hari ke-1',
    messageThirteen: 'Setelah dibatalkan, laporan acara tidak dapat diisi. Yakin ingin membatalkan acara?',
    messageThirty: 'Tolak permintaan {createUserName} untuk mengeluarkan toko?',
    messageThirtyEight: 'Berdasarkan operasional harian toko, atur Tag Toko menjadi',
    messageThirtyFive: 'Masukkan kata kunci untuk mencari toko',
    messageThirtyFour: 'Masukkan Distributor untuk {projectName}',
    messageThirtyNine: 'Berdasarkan acara, Tag Toko diatur menjadi',
    messageThirtyOne: 'Tanggal selesai tidak boleh sebelum tanggal mulai',
    messageThirtySeven: 'Hapus sampel yang dipilih beserta jumlah yang telah diisi?',
    messageThirtySix: 'Masukkan kata kunci untuk mencari Distributor',
    messageThirtyThree: 'Pilih tanggal kunjungan',
    messageThirtyTwo: 'Pemetaan Distributor berhasil. Informasi lainnya dapat dikumpulkan melalui kunjungan.',
    messageThree: 'Undang staf untuk mengaktifkan kelayakan menerima penghargaan.',
    messageTwelve: 'Pengajuan acara berhasil dikirim dan acara otomatis ditambahkan ke jadwal harian Anda.',
    messageTwentyEight: 'Lengkapi Informasi Anda',
    messageTwentyFive: 'Pilih jabatan',
    messageTwentyFour: 'Masukkan nama Anda',
    messageTwentyNine: 'Jika pengajuan disetujui, akses toko akan dilepas dan toko dipindahkan ke area "Pengembangan". Catatan operasional sebelumnya akan diarsipkan otomatis dan tidak dapat diubah. Harap lakukan dengan hati-hati.',
    messageTwentyOne: 'Tekan lama kode QR untuk menyimpannya ke album',
    messageTwentySeven: 'Aktifkan akses acara dan kirim SMS pemberitahuan ke nomor ponsel orang tersebut',
    messageTwentySix: 'Masukkan nomor ponsel lengkap',
    messageTwentyThree: 'Untuk memastikan tautan aktivasi terkirim, pastikan nomor telepon yang dimasukkan sudah benar.',
    messageTwentyTwo: 'Gagal mendapatkan gambar kode QR',
    messageTwo: 'Hapus Toko dari Grup (Toko tidak akan dihapus.)',
    messgaeEighteen: 'Tindak lanjut terlambat: Berdasarkan indikator operasional bisnis, frekuensi tindak lanjut ditetapkan untuk toko utama/toko uji coba. Jika tindak lanjut melewati interval yang ditentukan, sistem akan memberikan peringatan dini.',
    messgaeTwenty: 'Ikuti Program Insentif dengan Memindai Kode QR atau Mengeklik Tautan',
    networkError: 'Kesalahan jaringan',
    noAvailablePolicies: 'Tidak ada kebijakan yang tersedia',
    noData: 'Tidak Ada Data',
    noMore: 'Tidak ada lagi',
    noMoreData: 'Tidak ada data lainnya',
    noMoreProducts: 'Tidak Ada Produk Lainnya',
    noMoreStores: 'Tidak Ada Toko Lainnya',
    noMoreThan: 'Maksimal 5',
    noPermissionYet: 'Belum memiliki izin',
    nothingMore: 'Tidak ada lagi!',
    noticeCopiedFailed: 'Gagal menyalin pemberitahuan',
    noticeCopiedSuccessfully: 'Pemberitahuan berhasil disalin',
    passwordIsRequired: 'Kata sandi wajib diisi',
    pending: 'Menunggu',
    planningTheRoute: 'Merencanakan rute',
    pleaseChooseWhichDayToSell: 'Pilih hari penjualan',
    pleaseEnterAnInteger: 'Masukkan bilangan bulat',
    pleaseEnterGroupName: 'Masukkan nama grup',
    pleaseFillInTheSales: 'Masukkan jumlah penjualan',
    pleaseInputTheSales: 'Masukkan jumlah penjualan',
    pleaseSelectAGroup: 'Pilih Grup',
    pleaseSelectProduct: 'Pilih produk',
    pleaseSelectThePlan: 'Pilih rencana',
    productIsRequired: 'Produk wajib diisi',
    reasonIsRequired: 'Alasan wajib diisi',
    required: 'Wajib diisi',
    sellInFromAcmefogInIsRequired: 'Sell-In dari Acmefog wajib diisi',
    stayTuned: 'Nantikan',
    storeTagIsRequired: 'Tag Toko wajib diisi',
    successSave: 'Berhasil disimpan',
    uploadFailed: 'Gagal Mengunggah',
    usernameIsRequired: 'Nama pengguna wajib diisi'
  }
}
